import React from 'react';
import { observer } from 'mobx-react';
import { Flex, Box } from 'grid-styled';

import { Select } from '../styledSystem/Select';
import Option from '../styledSystem/Option';
import { Label } from '../styledSystem/Text';

const HTTPSelect = observer(
    class extends React.Component {
        onChange = ({ target }) => {
            console.log(
                'httpselect update:' + JSON.stringify(this.props.name)
            );

            const { model, name } = this.props;
            model[name] = target.value;

            console.log('httpselect set form valid');
            this.props.updateState({ formValid: true });
        };

        render() {
            const { model, name } = this.props;

            return (
                <Flex w={1}>
                    <Box w={1 / 2}>
                        <Label textStyle="labelNormal">Web Protocol</Label>
                    </Box>
                    <Box w={1 / 2}>
                        <Select onChange={this.onChange} value={model[name]}>
                            <Option value="http">HTTP</Option>
                            <Option value="https">HTTPS</Option>
                        </Select>
                    </Box>
                </Flex>
            );
        }
    }
);

export default observer(HTTPSelect);



// WEBPACK FOOTER //
// ./src/form/HTTPSelect.js